import axios from "axios";

const getPuedeCerrarTurno = async (idCaja, cierreCompartido) => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    idCaja: idCaja,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
    cierreCompartidoGrupoMangueras: cierreCompartido,
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/CierreDeTurno/PuedeCerrarTurno`, userData);
  return response.data;
};

const puedeCerrarTurno = {
  getPuedeCerrarTurno,
};

export default puedeCerrarTurno;
